import ApproveReturnCustomerOrder from './ApproveReturnCustomerOrder';
import SubmitCustomerOrder from './SubmitCustomerOrder';

export default async function HandleOrderSubmission(orderId, decisionStatusId, explanation, action) {
  // TODO: refactor bpm to have a single point of submission / state management so we don't have to use this service
  if (action) {
    return await ApproveReturnCustomerOrder(orderId, decisionStatusId, explanation, action);
  } else {
    return await SubmitCustomerOrder(orderId);
  }
}
